// Status eines Kurses — als i18n-Schlüssel.
export const STATUS_LABELS = {
	DRAFT: 'Draft',
	PUBLISHED: 'Published',
	ARCHIVED: 'Archived'
}
